"use strict";

import { fetchExtendedTags } from 'components/classInfoUtil';
import { hangleIngamePreview } from 'components/hooks/ingamePreviewHook';
import {CopyToClipboard} from 'react-copy-to-clipboard';
import { defineSimpleTerm, _I_ } from 'components/locs';
import { IconFontAwesome } from 'generics/icons';
import ReactDOM from 'react-dom';
import React from 'react';

const HOOKED_TAGS = {
  inGamePreview:true,
}

function getActiveTags( classInfo )  {
  const tags = fetchExtendedTags(
      classInfo
    ).filter(
      it => (it && HOOKED_TAGS[it.category])
    ).map(
      it => ({[it.category]:true})
    );

  return Object.assign({},  ...tags);
}


export class AdditionalActionBar extends React.Component  {
  constructor(props) {
    super(props)

    this.state = {
      copyUrlClicked: false
    }
  }

  copyItemUrl = () => {
    this.setState({copyUrlClicked: true});
    setTimeout(() => this.setState({copyUrlClicked: false}), 400);
  }

  render() {
    const {  classInfo, appId  } = this.props;
    const {
      inGamePreview,
    } = getActiveTags(classInfo);
    const urlItem = window.location.origin + "/?n=" + encodeURIComponent(classInfo.market_hash_name) + "&viewitem=&a=" + appId;

    return (<div className="actionBar">
      {inGamePreview && (
        <div className="action ingamePreview"
             onClick={() => hangleIngamePreview(appId, classInfo)}>
          <IconFontAwesome type="eye"/>&nbsp;{_I_("ActionBar.action.ingamePreview")}
        </div>
      )}
      <CopyToClipboard text={urlItem}>
        <div className="action ingamePreview"
             onClick={() => {
               this.copyItemUrl();
             }}>
          <IconFontAwesome type="clone"/>&nbsp;
          {
            this.state.copyUrlClicked ? _I_("ActionBar.action.previewCopied") : _I_("ActionBar.action.previewShare")
          }
        </div>
      </CopyToClipboard>

    </div>);
  }
}

defineSimpleTerm( "ActionBar.action.previewShare",  "Share",       {
  "ru_RU": "Поделиться"
})

defineSimpleTerm( "ActionBar.action.previewCopied",  "Copied!",       {
  "ru_RU": "Скопировано!"
})

defineSimpleTerm( "ActionBar.action.ingamePreview",  "View in game",       {
  "ru_RU": "Посмотреть в игре",
  "cs_CZ": "Zobrazit ve hře",
  "fr_FR": "Voir en jeu",
  "de_DE": "Im Spiel ansehen",
  "it_IT": "Vedi in gioco",
  "ko_KR": "게임 내에서 확인하기",
  "pl_PL": "Obejrzyj w grze",
  "pt_PT": "View in game",
  "es_ES": "Ver en el juego",
  "zh_CN": "在游戏中查看",
  "zh_TW": "在遊戲中查看"
} );

